export default __webpack_public_path__ + "93d8445f.png";